import { formatDistanceToNowStrict } from "date-fns";
import {
  cs,
  da,
  de,
  enUS,
  es,
  fi,
  fr,
  it,
  nl,
  pl,
  pt,
  ro,
  sl,
  sv,
} from "date-fns/locale";
import { TFunction } from "i18next";

const localeMapping = {
  en: enUS,
  fr: fr,
  de: de,
  es: es,
  it: it,
  nl: nl,
  pt: pt,
  sv: sv,
  da: da,
  fi: fi,
  cs: cs,
  sl: sl,
  pl: pl,
  ro: ro,
};

export const convertToRelativeTime = (
  prevDate: string,
  localeCode = "en",
  t?: TFunction
): string => {
  const locale = localeMapping[localeCode] || enUS;

  const diff = formatDistanceToNowStrict(new Date(prevDate), {
    addSuffix: true,
    locale,
  });

  if (diff.includes("second")) {
    if (t) {
      return t("just now");
    }
    return "just now";
  }

  return diff;
};
